import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: ${({ theme }) => theme.spacing(2.5)};

  height: 100%;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme }) =>
    `${theme.spacing(1.5)} ${theme.spacing(4)} ${theme.spacing(4)}`};
`;

export const Body = styled.div`
  flex: 1;
  overflow: auto;
`;
